import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, CartesianGrid, Legend } from 'recharts';
import DataTablePageDynamic from '../../../component/Table/DataTablePageDynamic';

const DashboardStayNest = () => {
    const [revenue, setRevenue] = useState([]);
    const [loadingRevenue, setLoadingRevenue] = useState(true);

    const [occupancy, setOccupancy] = useState([]);
    const [loadingOccupancy, setLoadingOccupancy] = useState(true);

    const [adr, setAdr] = useState([]);
    const [loadingAdr, setLoadingAdr] = useState(true);

    const [keys, setKeys] = useState([]);
    const [columns, setColumns] = useState([]);

    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [error, setError] = useState(null);

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_OCCUPANCY = "api/staynest/dashboard/Report/occupancy";
    const PATH_REVENUE = "api/staynest/dashboard/Report/revenue";
    const PATH_ADR = "api/staynest/dashboard/Report/adr";

    // Fetch data from the API
    const fetchData = async (URL, config) => {
        try {
            const response = await axios.get(URL, config);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        setLoadingOccupancy(true);
        setLoadingRevenue(true);
        setLoadingAdr(true);

        fetchData(`${BASE_URL}${PATH_OCCUPANCY}`, {}).then((data) => {
            setOccupancy(data);
        }).finally(() => {
            setLoadingOccupancy(false);
        });

        fetchData(`${BASE_URL}${PATH_REVENUE}`, {}).then((data) => {
            setRevenue(data);
        }).finally(() => {
            setLoadingRevenue(false);
        });

        fetchData(`${BASE_URL}${PATH_ADR}`, {}).then((data) => {
            setAdr(data);
        }).finally(() => {
            setLoadingAdr(false);
        });
    }, []);

    useEffect(() => {
        setKeys(adr.length > 0 ? Object.keys(adr[0]) : []);
    }, [adr]);

    useEffect(() => {
        setColumns(keys.map(key => ({
            Header: key.charAt(0).toUpperCase() + key.slice(1),
            accessor: key
        })));
    }, [keys]);

    if (error) {
        return <div>Error: {error}</div>;
    }
    return (
        <div className='p-6'>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="rounded-2xl shadow-lg overflow-hidden bg-white p-3">
                    <h2 className="text-xl font-semibold mb-4">Revenue Report (Rp)</h2>
                    {loadingRevenue ? (
                        <center><h1>Loading...</h1></center>
                    ) : (
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={revenue}>
                                <XAxis dataKey="period" />
                                <YAxis tickSize={10} />
                                <Tooltip formatter={(value) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(value)} />
                                <Bar dataKey="total_revenue" fill="#4f46e5" />
                            </BarChart>
                        </ResponsiveContainer>
                    )}
                </div>

                <div className="rounded-2xl shadow-lg overflow-hidden bg-white p-3">
                    <h2 className="text-xl font-semibold mb-4">Occupancy Report (%)</h2>
                    {loadingOccupancy ? (
                        <center><h1>Loading...</h1></center>
                    ) : (
                        <ResponsiveContainer width="100%" height={300}>
                            <LineChart data={occupancy}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="period" />
                                <YAxis />
                                <Tooltip formatter={(value) => `${value}%`} />
                                <Legend />
                                <Line type="monotone" dataKey="occupancy_percent" stroke="#16a34a" strokeWidth={3} dot={{ r: 5 }} />
                            </LineChart>
                        </ResponsiveContainer>
                    )}
                </div>


            </div>

            <div className="rounded-2xl shadow-lg overflow-hidden bg-white p-3">
                <h2 className="text-xl font-semibold mb-4">Data ADR</h2>
                {loadingAdr ? (
                    <center><h1>Loading...</h1></center>
                ) : (
                    <DataTablePageDynamic
                        data={adr}
                        nextPage={false}
                        columns={columns}
                        elementClass="p-1"
                        actions={[]}
                        onDataChange={(pageIndex, pageSize, sortBy) => {                            
                        }} />
                )}
            </div>

        </div>
    );
};

export default DashboardStayNest;